/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_FinanceIntegrationService_AppServices_PrivateTicker_PrivateStockDataSampleDownloadResponse } from '../models/Wealthlane_FinanceIntegrationService_AppServices_PrivateTicker_PrivateStockDataSampleDownloadResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PrivateTickerStockImportService {

    /**
     * @param formData 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppPrivateTickerStockImportImport(
formData?: {
File?: Blob;
},
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/private-ticker-stock-import/import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_AppServices_PrivateTicker_PrivateStockDataSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppPrivateTickerStockImportDownloadSample(): CancelablePromise<Wealthlane_FinanceIntegrationService_AppServices_PrivateTicker_PrivateStockDataSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/private-ticker-stock-import/download-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
